<template>
    <div class="footer" :class="{ 'black-mode': isHome }">
        <div class="inner">
            <div class="shares-number">
                GREENLAND HK 00337.HK
                <!-- <span class="text-green shqy" id="numberone">0.00</span>
                <span class="text-green up_down" id="numbertwo">0.00</span> -->
            </div>
            <div class="munes tc">
                <a @click="handleGo('/pageMap')">{{ $t(`footerPage.nameWZDT`) }}</a>
                <a href="https://www.ldjt.com.cn/" target="view_window">{{ $t(`footerPage.nameLDJT`) }}</a>
                <a @click="handleDisclaimer">{{ $t(`footerPage.nameMZSM`) }}</a>
                <a href="javascript:;" class="pointer"></a>
                <p style="margin-top: 10px;" class="tc">
                    <a href="javascript:;" class="pointer"></a>
                    <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502004616" target="_blank"
                        title="公安备案号：31010502004616" style="text-decoration: none;">
                        <img :src="'./static/images/filings.png?time=' + baseConfigInfo.setImgPathRandom"
                            title="1606891428906418.png" alt="备案图标.png">{{ $t(`footerPage.nameBAA`) }}：31010502004616</a>
                    <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502004616" target="_blank"
                        title="沪ICP备05042279号-3" style="text-decoration: none;">{{ $t(`footerPage.nameBAB`) }}</a>
                </p>
                <div class="copy-right">Copyright ©2015 GreenLand HongKong All Right Reserved.</div>
            </div>

        </div>

    </div>
</template>

<script>
export default {
    name: 'Footer',
    components: {},
    mixins: [],
    props: {},
    data() {
        return {

        }
    },
    computed: {
        isHome() {
            return this.$route.path === "/" || this.$route.name === "default";
        },
        baseConfigInfo() {
            return (
                localStorage.getItem('baseConfigInfo') &&
                JSON.parse(localStorage.getItem('baseConfigInfo'))
            )
        }
    },
    watch: {},
    created() { },
    mounted() {

    },
    destroyed() { },
    methods: {
        handleGo(path) {
            this.$router.push(path)
        },
        // 展示免责申明
        handleDisclaimer() {
            const resolve = this.$router.resolve({
                name: 'Disclaimer'
            })
            window.open(resolve.href, '_blank')
        }
    },
}
</script>

<style lang="scss" scoped>
.footer {
    padding: 20px 0;

    &.black-mode {
        padding-top: 30px;
        background: #000;
        color: #fff;

        .munes {
            color: #fff !important;
        }
    }

    .inner {
        width: 1400px;
        margin: 0 auto;
        padding: 0 15px;
        position: relative;

        .shares-number {
            position: absolute;
            right: 15px;
            top: 0;
            font-weight: bold;
            font-size: 16px;

            .text-green {
                color: #006f00;
            }
        }

        .munes {
            width: 100%;
            font-size: 14px;
            color: #333;

            a {
                padding: 0 16px;
                border-left: 2px solid #898989;

                &:first-child {
                    border-left: 0;
                }
            }

            img {
                max-width: 100%;
                height: auto;
                vertical-align: top;
            }

            .copy-right {
                padding-top: 8px;
            }
        }
    }
}

@media screen and (max-width: 1600px) {
    .footer {
        .inner {
            width: 1200px;
        }
    }
}

@media screen and (max-width: 1400px) {
    .footer {
        .inner {
            width: 100%;
        }
    }
}

@media screen and (max-width: 1100px) {
    .footer {
        &.black-mode {
            min-width: 850px;
        }

        .inner {
            .shares-number {
                top: -24px;
                right: 50%;
                margin-right: -177px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/base/Footer.vue